﻿import {observable, action, computed, createTransformer, reaction, extendObservable} from "mobx";
import FluxoStore from "../../comum/stores/FluxoStore";
import _ from "lodash";
import {getByAtribute} from "../../../../utils/formatar";
import moment from "moment/moment";

export default class FluxoSolicitacaoETTStore extends FluxoStore {

    @observable alertaValidacaoCPF;
    @observable obstrucaoValidacaoCPF;

    constructor(parametrosGeraisStore, loginStore, tituloPaginaStore, validationStore, modalStore, loadingPanelStore) {
        super(parametrosGeraisStore, loginStore, tituloPaginaStore, validationStore, modalStore, loadingPanelStore);

        this.alertaValidacaoCPF = [];
        this.obstrucaoValidacaoCPF = [];
        this.dadosOk = true;
    }

    @computed
    get exibeAvisoCpfDiferente() {
        return this.solicitacaoEtt.cpfDiferenteInformado && !this.isTarefaHTConfirmarAlocacao;
    }


    @computed
    get exibeIndicacaoSolicitacaoEtt() {
        return this.indicacaoInformada && this.isFluxoEtt;
    }
    @computed
    get tarefaPermiteAlterarDataInicio() {
        return this.isTarefaHTConfirmarAlocacao;
    }

    //TODO: extrair dados de FluxoStore que pertence apenas ao fluxo de solicitação de contratação
    carregarLista(tipoDetalhamento, setTitulo) {
        this.getSolicitacao(tipoDetalhamento, setTitulo);
        this.carregarLotacoes();

        this.loadingPanelStore.setIsLoading("dadosBasicosLoading", true);

        const dadosPromise = Promise.all([
            this.motivoGeralService.listMotivoAtraso().then(response => {
                this.motivosAtraso = response.data;
            }),
            this.motivoGeralService.listMotivoSubstituicaoMOTAlocada().then(response => {
                this.motivosSubstituicao = response.data;
            }),
            this.motivoGeralService.listMotivoDesistenciaAlocacaoETT().then(response => {
                this.motivosDesistenciaAlocacaoETT = response.data;
            }),
            this.ettService.list().then(response => {
                this.etts = response.data;
            }),
            this.motivoGeralService.listMotivoSubstituicaoCPF().then(response => {
                this.motivosSubstituicaoCpf = response.data;
            })
        ]);

        dadosPromise.then(() => {
            this.loadingPanelStore.setIsLoading("dadosBasicosLoading", false);
        }).catch(error => {
            this.loadingPanelStore.setIsLoading("dadosBasicosLoading", false);
            console.log(error);
        })
    }

    // Ações
    reivindicar(id) {
        if (id) {
            if (this.isFluxoNovo){
                this.solicitacaoEtt.salarioDiferente = null;

                if(this.solicitacaoEtt.dadosMot.momentDataNascimento !== null && this.solicitacaoEtt.dadosMot.momentDataNascimento !== "")
                    this.solicitacaoEtt.dadosMot.dataNascimento = this.solicitacaoEtt.dadosMot.momentDataNascimento.toJSON();
                this.detalhesTarefa.solicitacaoEtt = this.solicitacaoEtt;

                var tramite = this.montarTramiteFluxo(id, "REIVINDICAR");
                return this.fluxoService.tramitarFluxo(tramite);
            } else {
                super.reivindicar(id);
            }
        }
    }

    confirmarAlocacao(id) {
        if (id) {
            if (this.isFluxoNovo){
                if(this.solicitacaoEtt.dadosMot.momentDataNascimento !== null && this.solicitacaoEtt.dadosMot.momentDataNascimento !== "")
                    this.solicitacaoEtt.dadosMot.dataNascimento = this.solicitacaoEtt.dadosMot.momentDataNascimento.toJSON();
                this.detalhesTarefa.solicitacaoEtt = this.solicitacaoEtt;
                var tramite = this.montarTramiteFluxo(id, "CONFIRMAR_ALOCACAO");
                return this.fluxoService.tramitarFluxo(tramite);
            } else {
                super.confirmarAlocacao(id);
            }
        }
    }

    confirmarContratacao(id) {

        if (id) {
            if (this.isFluxoNovo){
                this.detalhesTarefa.solicitacaoEtt = this.confirmarAlocacaoETT;
                this.solicitacaoEtt = this.confirmarAlocacaoETT;
                var tramite = this.montarTramiteFluxo(id, "CONFIRMAR_CONTRATACAO");
                return this.fluxoService.tramitarFluxo(tramite);
            } else {
                super.confirmarContratacao(id);
            }
        }
    }

    aprovar(id) { // tarefa aprovada
        if (id) {
            if (this.isFluxoNovo){
                var tramite = this.montarTramiteFluxo(id, "APPROVE");
                return this.fluxoService.tramitarFluxo(tramite);
            } else {
                super.aprovar(id);
            }
        }
    }

    rejeitar(id) {
        this.validacaoStore.desabilitarValidacao = false;
        if (id) {
            if (this.isFluxoNovo){
                var tramite = this.montarTramiteFluxo(id, "REJECT");
                return this.fluxoService.tramitarFluxo(tramite);
            } else {
                super.rejeitar(id);
            }
        }
    }

    desistir(id) {
        if (id) {
            if (this.isFluxoNovo){
                this.validacaoStore.desabilitarValidacao = false;

                var tramite = this.montarTramiteFluxo(id, "DESISTIR");
                tramite.razaoDesistencia = this.confirmarAlocacaoETT.razaoDesistencia;

                return this.fluxoService.tramitarFluxo(tramite);
            } else {
                super.desistir(id);
            }
        }
    }

    cancelar(id) {
        this.validacaoStore.desabilitarValidacao = false;
        if (id) {
            return this.tarefaService.tramitar(id, this.nomeFluxo, this.idSolicitacao, "CANCELAR", null, this.observacoes, this.detalhesTarefa)
        }
    }
    
    getComentarios() {
        
        if (this.idSolicitacao) {
            if (this.isFluxoNovo){
                this.fluxoService.getHistoricoFLuxo("GloboMOTSolicitacaoEtt", this.idSolicitacao).then(response => {
                    this.comentarios = response.data;
                }).catch(error => {
                    console.log(error);
                });
            }
            else {
                super.getComentarios();
            }
        }
    }
    
    getTarefasFluxo(){
        if (this.isFluxoNovo){
            this.fluxoService.getEvolucaoFluxo(this.getIdFluxo).then(response => {
                //tratamento para não quebrar o detalhamento da prorrogação e término antecipado
                if(response && response.data && Array.isArray(response.data)) {
                    this.evolucaoFluxo = response.data;
                }
            }).catch(error => {
                console.log(error);
            });
        } else {
            super.getTarefasFluxo();
        }
    }

    // monta o dto de tramite. Relativo ao TramiteFluxoDTO do backend
    montarTramiteFluxo(idTask, acao){
        var tramite = {
            idTask: idTask,
            acao: acao,
            nomeFluxo: this.nomeFluxo,
            tipoFluxo: "solicitacaoEtt",
            tipoTarefa: this.nomeTarefa,
            idSolicitacao: this.solicitacaoEtt.idSolicitacao,
            idSolicitacaoEtt: this.solicitacaoEtt.idSolicitacaoEtt,
            comentario: this.observacoes, 
            dadosSolicitacao: this.solicitacao,
            dadosSolicitacaoEtt: this.solicitacaoEtt
        }
        return tramite
    }
    
    //RHFPP-1020
    setTipoEmailContratacao(value) {
        this.tipoEmailContratacao = value; // Atualiza o observável que o Select usa (string)
        // Converte para número para o atributo oficial da solicitação (para o backend)
        if (value === null || value === undefined || value === '') {
            this.solicitacao.tipoEmailContratacao = null;
        } else {
            this.solicitacao.tipoEmailContratacao = Number(value);
        }
    }       
}